import React, { useContext } from 'react';

export const defaultConfig = {
    appVersion: '',
    bugsnagApiKey: '',
    bugsnagReleaseStage: '',
    displayErrors: false,
    enableDebugBar: false,
    paymentsApiKey: '',
    paymentsApiModalIframeUrl: '',
    paymentsScriptUrl: '',
    recaptchaSiteKey: '',
    avatarBasePath: '',
    fileSigningBasePath: '',
    webpackPublicPath: '',
};

export type AppConfigData = typeof defaultConfig;

const appConfigContext = React.createContext<AppConfigData>(defaultConfig);

export const AppConfigProvider = appConfigContext.Provider;
export const AppConfigConsumer = appConfigContext.Consumer;

export function useAppConfig(): AppConfigData {
    const context = useContext(appConfigContext);

    if (context === undefined) {
        throw new Error('useAppConfig must be used within a AppConfigProvider');
    }

    return context;
}
